import { OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Subscription, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Apollo, gql } from 'apollo-angular';
import { NotificationService } from '../shared/notification/notification.service';

const query = gql`
    query Query($name: String!) {
        webAccountInfo(name: $name) {
            logo
            headerTitle
            headerSubTitle
            name
            themeColor
            isActive
            customerID
            creditCardProcessingMethod
            stripeAccountID
        }
    }
`;

@Component({
    selector: 'ols-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit, OnDestroy {
    imagePath: string;
    message: string;
    apolloSubscription: Subscription;

    constructor(
        private apollo: Apollo,
        private notificationService: NotificationService
    ) {}

    ngOnInit(): void {
        this.imagePath = 'assets/images/page-not-found.svg';
        this.apolloSubscription = this.apollo
            .query({ query })
            .pipe(
                map((result: any) => {
                    if (
                        result.data.webAccountInfo &&
                        !result.data.webAccountInfo.isActive
                    ) {
                        this.message =
                            'The website you are looking for is currently not available';
                    } else {
                        this.message =
                            "The website you are looking for couldn't be found";
                    }

                    return result.data.settings;
                }),
                catchError((err) => {
                    this.notificationService.showFailure(err);
                    return of(null);
                })
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.apolloSubscription.unsubscribe();
    }
}
